import styled from "../../../../_snowpack/pkg/styled-components.js";
export const CardContainer = styled.div`
	width: 50%;
	min-width: 350px;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	align-items: center;
`;
